module.exports = __webpack_public_path__ + "static/media/view budget.9ad29b29.svg";